export default {
  CREATE: 'create',
  PROFILE: 'profile',
  EDIT: 'update',
};
